var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22 40C29.1797 40 35 34.1797 35 27C35 19.8203 29.1797 14 22 14C14.8203 14 9 19.8203 9 27C9 34.1797 14.8203 40 22 40Z",
    fill: "#2086BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 40C29.1797 40 35 34.1797 35 27C35 19.8203 29.1797 14 22 14C14.8203 14 9 19.8203 9 27C9 34.1797 14.8203 40 22 40Z",
    stroke: "#2086BD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.85 14.475C39.9992 14.1633 41.1843 14.0036 42.375 14C45.8228 14 49.1294 15.3696 51.5674 17.8076C54.0054 20.2456 55.375 23.5522 55.375 27C55.375 30.4478 54.0054 33.7544 51.5674 36.1924C49.1294 38.6304 45.8228 40 42.375 40",
    stroke: "#2086BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 49.35C6.02987 46.4615 8.72509 44.1038 11.858 42.4763C14.9909 40.8488 18.4695 39.9991 22 39.9991C25.5305 39.9991 29.0091 40.8488 32.142 42.4763C35.2749 44.1038 37.9701 46.4615 40 49.35",
    stroke: "#2086BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.375 40C45.9058 39.9978 49.3851 40.8464 52.5183 42.474C55.6516 44.1015 58.3465 46.4601 60.375 49.35",
    stroke: "#2086BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatars);
export default __webpack_public_path__ + "static/media/avatars.4c3bf8ea35ca145fb691b47f7cb8252a.svg";
export { ForwardRef as ReactComponent };